const SECOND = 1000;
const MINUTE = 60 * SECOND;

export const POPUP_ALONE_SECONDS = 30;
export const POPUP_ALONE_TIMEOUT = MINUTE;
export const POPUP_ALONE_INTERVAL = SECOND;
